import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@safedns/skydns-ui-react-lib';

import sprite from '../../icons/sprite.svg';
import {
  BASE_URL,
  useGetMenuQuery,
  useGetUserQuery,
} from '../../services/ADapi';

import './Menu.scss';

const menuIcons = {
  submenu__main_page: 'main-menu',
  submenu__main_settings: 'settings',
  submenu__main_categories: 'categories',
  submenu__main_ad: 'ad',
  submenu__main_lists: 'lists',
  submenu__main_statistics: 'stat',
  'submenu__main-new_statistics': 'stat',
  submenu__main_support: 'help',
  submenu__main_account: 'account',
  submenu__main_user_administration: 'user',
  submenu__main_partners: 'user',
};

const NAV_COLLAPSED_KEY = 'nav_collapsed';

const Menu = () => {
  const { data: { user_id, username } = {} } = useGetUserQuery();
  const { data: navbar = [] } = useGetMenuQuery(user_id);

  const [isNavCollapsed, setIsNavCollapsed] = useState(() => {
    const saved = localStorage.getItem(NAV_COLLAPSED_KEY);
    return saved === null ? false : saved === 'true';
  });

  const toggleNavCollapsed = () => {
    setIsNavCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem(NAV_COLLAPSED_KEY, String(next));
      return next;
    });
  };

  const renderMenu = () => {
    return (
      <>
        {navbar.map((item, index) => {
          const iconId = menuIcons[item.css_class] || 'main-menu';
          const isActive = item.css_class === 'submenu__main_ad';

          return (
            <NavLink
              key={item.url || index}
              to={`${BASE_URL}${item.url}`}
              id={String(index)}
              className={`${isActive ? 'nav-item-active' : 'nav-item'}`}
              state={item.title}
              title={item.title}
            >
              <Icon
                id={iconId}
                sprite={sprite}
                className="nav-item-icon"
                color="#637083"
                width={20}
                height={20}
              />
              <span className="nav-item-label">{item.title}</span>
            </NavLink>
          );
        })}
      </>
    );
  };

  return (
    <div className={`nav${isNavCollapsed ? ' nav-collapsed' : ''}`}>
      <div className="nav-info">
        <p className="nav-info-username">{username}</p>
        <button
          type="button"
          className="nav-info-toggle"
          onClick={toggleNavCollapsed}
          aria-label={isNavCollapsed ? 'Развернуть меню' : 'Свернуть меню'}
        >
          <Icon
            id="collapse-menu"
            sprite={sprite}
            className="nav-info-toggle-icon"
            color="#637083"
            width={20}
            height={20}
          />
        </button>
      </div>
      {renderMenu()}
    </div>
  );
};

export default Menu;
